export const incertitudeCategories = [
  "Visite de site",
  "Etude historique et documentaire",
  "Implantation des sondages/ ouvrages et réalisation des prélèvements",
  "Conditionnement et conservation des échantillons prélevés",
  "Méthodes analytiques (laboratoire)",
  "Programme analytique",
  "Schéma conceptuel / Conclusions et recommandations",
];
